import { DSV_FORMAT_TSV, DsvUtils } from '../dsv/dsv.utils';

export class TsvUtils {
  public static toTsv<T>(data: T[], columnKeys: (keyof T)[]): string {
    return DsvUtils.serialize(data, columnKeys, DSV_FORMAT_TSV.separator);
  }

  public static parseTsv<T = Record<string, string>>(
    tsvString: string,
    options?: { columnKeys?: string[]; hasHeaders?: boolean },
  ): { rows: T[]; warnings: string[] } {
    return DsvUtils.parse<T>(tsvString, DSV_FORMAT_TSV.separator, options);
  }

  public static downloadTsv(tsvContent: string, fileName: string): void {
    DsvUtils.download(tsvContent, fileName, DSV_FORMAT_TSV);
  }

  public static isTsv(text: string): boolean {
    return DsvUtils.isDelimited(text, DSV_FORMAT_TSV.separator);
  }
}
